import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import DraftImpactPersonRow from './DraftImpactPersonRow';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';

interface DraftImpactCardProps extends React.HTMLAttributes<HTMLDivElement> {
  draft: ChangeDraftVm;
  /**
   * Odmowa podglądu paczki. Kwot wtedy nie znamy, a zero na tej karcie
   * czytałoby się jako „paczka nic nie kosztuje” — więc zamiast liczb idzie
   * powód z backendu.
   */
  amountsError?: Error | null;
}

/**
 * Karta „Wpływ paczki” — panel boczny w trybie edycji. Bilans szkicu w całości,
 * rozbity na osoby, i wartość rezerwacji po wprowadzeniu paczki.
 */
const DraftImpactCard = ({
  draft,
  amountsError,
  ...props
}: DraftImpactCardProps) => (
  <InfoCard {...props}>
    <InfoCardHeader title="Wpływ paczki" />

    {amountsError ? (
      <InfoCardBody>
        <p className="text-sm text-error-200">
          Nie udało się przeliczyć kwot paczki. {amountsError.message}
        </p>
      </InfoCardBody>
    ) : (
      <InfoCardBody>
        <div className="text-2xl font-extrabold tabular-nums text-ink">
          <MoneyAmountList values={draft.totalDelta} variant="signed" />
        </div>

        {draft.impactByPerson.map((entry) => (
          <DraftImpactPersonRow key={entry.personId} entry={entry} />
        ))}

        <InfoCardRow divided label="Rezerwacja po zmianie">
          <span className="font-semibold tabular-nums text-ink">
            <MoneyAmountList values={draft.bookingValueAfter} />
          </span>
        </InfoCardRow>
      </InfoCardBody>
    )}
  </InfoCard>
);

export default DraftImpactCard;
